<template>
  <div>
    <VoucherViewerModal
      :vouchers="voucherModal.vouchers"
      :visible="voucherModal.visible"
      @close="voucherModal.visible = false"
    />
    <div v-if="allRide?.ride && compareToUserId( allRide.ride.authorId )" class="view-toggle-container mb-4">
      <div class="btn-group">
        <button 
          class="btn" 
          style="font-size: 1.6rem !important;"
          :class="{'btn-primary': !showCalendarView, 'btn-outline-primary': showCalendarView}"
          @click="showCalendarView = false">
                          <i class="fas fa-list"></i> {{ t('listView') }}
        </button>
        <button 
          class="btn" 
          style="font-size: 1.6rem !important;"
          :class="{'btn-primary': showCalendarView, 'btn-outline-primary': !showCalendarView}"
          @click="showCalendarView = true">
                          <i class="fas fa-calendar"></i> {{ t('calendarView') }}
        </button>
      </div>
    </div>

      <TripCalendarView v-if="showCalendarView" :key="rideId + '-' + showCalendarView">
      </TripCalendarView>

    
    <div 
      v-for="(dailyActivites, index) in allRide.attractionsByDay"
      :key="index"
      class="day-at-trip"
      :id="'daily_attraction_day_' + index"
      >
      <div v-if="!showCalendarView">
        <div class="row mb-3">
                      <div class="ride-day-header d-flex">
              <div class="ride-day-date" :style="{ marginLeft: isEnglish ? '0' : 'auto', marginRight: isEnglish ? 'auto' : '0' }">
                             <p :class="['day-number', 'mb-0', 'fw-bold', 'fs-4']" :style="{ textAlign: isEnglish ? 'left' : 'right' }">
                   {{ t('dayNumber', { number: index + 1 }) }}
                </p>
                             <div class="ride-date-and-location d-flex gap-md-4" :style="{ textAlign: isEnglish ? 'left' : 'right', justifyContent: isEnglish ? 'flex-start' : 'flex-end' }">
                <p 
                  v-if="internallShouldPresentTheDates"
                  class="mb-0 opacity-75 fs-7"
                  >
                  {{ dailyActivites.dateTime.split('00:00')[0] }}
                </p>
                <p 
                  v-if="activAccommodation( dailyActivites ).cuntry_and_city"
                  class="mb-0 d-flex align-items-center">
                  {{activAccommodation( dailyActivites ).cuntry_and_city}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="trip-btn-wraper"
          v-if="allRide?.ride && compareToUserId( allRide.ride.authorId ) && !isRideLocked">
          
          <a
            v-if="isSubdomain" 
            class="trip-default-btn" @click="chouseTheRightWayToAddAtraction(index)">{{ t('moreActivitiesInArea') }}<span>+</span></a>
          <a
            v-else
            class="trip-default-btn" @click="chouseTheRightWayToAddAtraction(index)">{{ t('addActivity') }}<span>+</span></a>
          
          <a class="trip-default-btn"
              @click="goToBaseRideAccommodation({ baseRideAccommodation: dailyActivites.base_trip_accommodation, dayIndex: index })"
              v-if="!booked( dailyActivites )">{{ t('addAccommodation') }} <span>+</span></a>
          <!-- <a class="trip-default-btn" @click="goToRideAccommodation( dailyActivites.accommodation )">הוספת לינה +</a> -->
                      <a class="trip-default-btn " @click="addNewDayToRideInternal(index)">{{ t('addDay') }} <span>+</span></a>
          <a 
            v-if="isUserManager"
            class="trip-default-btn"
            @click="moveDayAttractionsInternal(dailyActivites, index)">{{ t('moveAllActivities') }}
          </a>
                      <a class="trip-default-btn trip-outline" @click="confirmAndRemoveDay(index)">{{ t('deleteDay') }}
            <span class="material-icons" >delete</span>
          </a>
        </div>

      <div 
        v-if="fullscreenImageSrc"
        class="fullscreen-overlay"
        @click="closeImageFullscreen">
        <button 
          class="close-button"
          @click="closeImageFullscreen"
        >
          X
        </button>
        <img
          :src="fullscreenImageSrc"
          alt="Fullscreen image"
        />
      </div>
       <!-- start of attraction part -->

        <div
          class="transparent-background-primary"
        >
          <div
            class="trip-btn-wraper"
            v-if="allRide?.ride &&
                      (
                        (allRide.ride.is_based_ride && compareToUserId( allRide.ride.authorId ) ) ||
                        (isUserManager && compareToUserId( allRide.ride.authorId ) )
                      ) &&
                      !getDayExtraInformationByDate( dailyActivites.dateTime ) &&
                      !isRideLocked"
            >
            <a class="trip-default-btn" @click="openExtraInformationForRide(dailyActivites.dateTime)">{{ t('addGeneralInfo') }}<span>+</span></a>
          </div>
          <div
            class="trip-btn-wraper"
            v-else-if="allRide?.ride &&
                      (
                        (allRide.ride.is_based_ride && compareToUserId( allRide.ride.authorId ) ) ||
                        (isUserManager && compareToUserId( allRide.ride.authorId ) )
                      ) &&
                      getDayExtraInformationByDate( dailyActivites.dateTime ) &&
                      !isRideLocked"
            >
            <a 
              class="trip-default-btn"
              @click="internalEditExtraInformationForRide( getDayExtraInformationByDate( dailyActivites.dateTime ))"
            >
              {{ t('editExtraInfo') }}
            </a>
          </div>
          <CollapseText 
            class="ride-detailes"
            v-if="getDayExtraInformationByDate( dailyActivites.dateTime )"
            :text="getDayExtraInformationByDate( dailyActivites.dateTime ).text"
            :uniqueId="Math.random()"
          >
          </CollapseText>
          
          <div 
            v-for="(attraction, idx) in dailyActivites.daily_attractions"
            :key="idx"
            >
            <div class="activity card border-0 rounded-4 shadow-sm mb-3">
                <div class="card-body">
                    <div class="internal-row">
                        <div class="d-flex justify-content-between align-items-center mb-2" style="width: 100%;">
                          <p class="activity-name fs-4 text-end mb-0">
                            {{attraction.title}}
                          </p>
                          <div class="d-flex align-items-top font-64 ride-activity-index" :class="idx+1 >= 10 ? 'font-32-and_2_digits' : ''">
                            {{idx+1}}
                          </div>
                        </div>
                        <div class="internal-row">
                          <div class="attraction-image-contenir internal-col-4">
                            <img
                              width="240"
                              height="320"
                              v-if="attraction.image"
                              :originalimage="attraction.image"
                              :src="$store.getters.getResizeImageForMobileDevices(attraction.image)"
                              class="attraction-main-image"
                              @click="toggleImageFullscreen(attraction.image)"
                              @error="loadErrorImage($event, attraction.image)"
                              :alt="attraction.title"
                              >
                              <p v-if="attraction.imageHtmlAttributions" v-html="getImageHtmlAttributions( attraction.imageHtmlAttributions[0])"></p>
                          </div>
                          <div class="internal-col-8">
                            <div class="">
                                <CollapseText 
                                  class="attraction_information"
                                  :text="attraction.text"
                                  :uniqueId="Math.random()"
                                >
                                </CollapseText>
                                <div 
                                  v-if="attraction.rate && !isSubdomain"
                                  class="side_star-location"
                                >
                                  <img
                                    width="1024px"
                                    height="1024px"
                                    src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fgoogle_G_icon_transparent.png?alt=media&token=f80515fc-802b-413e-ade2-e16b125e3c05"
                                    alt="Image"
                                  >
                                  <h5>
                                    {{attraction.rate}}
                                  </h5>
                                  <img
                                    width="15px"
                                    height="12px"
                                    src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fstar_icon.png?alt=media&token=f2eb5419-e0fd-4c62-b6c2-9499544a5c03"
                                    alt="Star"
                                  >
                                </div>
                                <!-- Video, Audio media section -->
                                <div
                                  v-if="attraction.videoUrl || attraction.audioUrl"
                                  class="attraction-media-section mt-3"
                                >
                                  <div v-if="attraction.videoUrl" class="attraction-media-item">
                                    <p class="attraction-media-label mb-1">{{ t('video') }}</p>
                                    <video
                                      controls
                                      preload="none"
                                      class="attraction-media-video"
                                      :src="attraction.videoUrl"
                                      poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 180'%3E%3Crect fill='%23ddd' width='320' height='180'/%3E%3Cpolygon fill='%23999' points='130,70 130,110 160,90'/%3E%3C/svg%3E"
                                    >
                                      {{ t('videoTagNotSupported') }}
                                    </video>
                                  </div>
                                  <div v-if="attraction.audioUrl" class="attraction-media-item">
                                    <p class="attraction-media-label mb-1">{{ t('audio') }}</p>
                                    <audio
                                      controls
                                      class="attraction-media-audio"
                                      :src="attraction.audioUrl"
                                    >
                                      {{ t('audioTagNotSupported') }}
                                    </audio>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    <div class="attraction-buttons-primary" dir="ltr">
                      <div 
                        @click="openGoogleMapsLink(attraction)"
                        class="clikable attraction-nav-button"
                      >
                        <img
                          class="attraction-nav-icon"
                          src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fmap_letter%2Fmaps_48dp.png?alt=media&token=fd8423d7-27f0-4790-b84d-dbda827197dc"
                          alt="Google Maps"
                          loading="lazy"
                        />
                        <span class="attraction-nav-label">{{ t('navigateToDestination') }}</span>
                      </div>

                      <div
                        @click="showModalAttraction({ 'attractionId': attraction.id, 'sorce': 'internal' })"
                        class="clikable attraction-option-button"
                        :aria-label="t('moreDetails')"
                        :title="t('moreDetails')"
                      >
                        <span class="material-icons">info</span>
                      </div>
                    </div>
                    <div
                      v-if="haveAffiliateSourceLink(attraction)"
                      class="attraction-buttons-container attraction-buttons-extra"
                      dir="ltr"
                    >
                      <div
                        @click="openAffiliateSourceLink(attraction)"
                        class="clikable attraction-button get-your-guide"
                        :style="{ backgroundColor: `${affiliateSourceColor(attraction)} !important` }"
                      >
                        <img :src="affiliateSourceIconLink(attraction)" alt="Affiliate" />
                        {{ affiliateSourceText(attraction) }}
                      </div>
                    </div>

                    <div
                      v-if="attraction.voucherUrls && attraction.voucherUrls.length"
                      class="attraction-buttons-container attraction-voucher-row"
                      dir="ltr"
                    >
                      <div
                        @click="openVoucherModal(attraction.voucherUrls)"
                        class="clikable attraction-button voucher-button"
                      >
                        <span class="material-icons" style="color: white;">receipt_long</span>
                        {{ attraction.voucherUrls.length > 1 ? t('voucherPlural') : t('voucher') }}
                      </div>
                    </div>

                    <div 
                      class="attraction-buttons-container"
                      style="justify-content: flex-end !important;"
                      v-if="allRide?.ride && compareToUserId( allRide.ride.authorId ) && !isRideLocked"
                    >
                      <div 
                        @click="removeAttractionFromRideInternal(attraction.id)"
                        class="clikable attraction-button secondery_button"
                      >
                      <span class="material-icons" >delete</span>
                        {{ t('remove') }}
                      </div>

                      <div 
                        v-if="compareToUserId(attraction.authorId)"
                        @click="editAttraction(attraction.id)"
                        class="clikable attraction-button secondery_button"
                      >
                        <span class="material-icons">edit</span>
                          {{ t('edit') }}
                      </div>
                      <div 
                        v-if="compareToUserId(allRide.ride.authorId)"
                        @click="openUpdateAttractionTime(attraction)"
                        class="clikable attraction-button secondery_button"
                      >
                        <span class="material-icons">edit</span>
                          {{ t('changeDate') }}
                      </div>
                    </div>
                </div>
            </div>
          </div>
        
        <div
          class=""
          :id="(activAccommodation( dailyActivites ).id + '_acommodation_ref_id')"
          v-if="( Object.keys( activAccommodation( dailyActivites ) ).length )"
          >
            <div class="activity card border-0 rounded-4 shadow-sm mb-3">
                <div class="card-body">
                    <div class="internal-row">
                        <div class="d-flex justify-content-between align-items-start mb-2" style="width: 100%;">
                          <div class="text-end">
                            <p 
                              class="activity-name fs-4 text-end mb-0"
                              v-if="activAccommodation( dailyActivites ).cuntry_and_city"
                              >
                              {{ t('accommodation') }} {{activAccommodation( dailyActivites ).cuntry_and_city}}                              
                            </p>
                            <p 
                              class="activity-name fs-4 text-end mb-0"
                            >
                              {{activAccommodation( dailyActivites ).name}}
                            </p>
                          </div>
                          <div class="d-flex align-items-top font-64 ride-accommodation-index">
                            <i
                              class="fa-solid fa-house">
                            </i>
                          </div>
                        </div>
                        <div class="internal-row">
                          <div class="attraction-image-contenir internal-col-4">
                            <img
                              v-if="activAccommodation( dailyActivites ).image"
                              :originalimage="activAccommodation( dailyActivites ).image"
                              :src="activAccommodation( dailyActivites ).image"
                              class="attraction-main-image"
                              @click="toggleImageFullscreen(activAccommodation( dailyActivites ).image)"
                              @error="loadErrorImage($event, activAccommodation( dailyActivites ).image)"
                              :alt="activAccommodation( dailyActivites ).name"
                              width="240"
                              height="320"

                              >
                          </div>
                          <div class="internal-col-8">
                            <div class="">
                                <CollapseText 
                                  class="attraction_information"
                                  :text="activAccommodation( dailyActivites ).text"
                                  :uniqueId="Math.random()"
                                >
                                </CollapseText>
                                <div 
                                  v-if="activAccommodation( dailyActivites ).rate && !isSubdomain"
                                  class="side_star-location"
                                >
                                  <img
                                  src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fgoogle_G_icon_transparent.png?alt=media&token=f80515fc-802b-413e-ade2-e16b125e3c05"
                                  alt="Image"
                                  width="1024px"
                                  height="1024px"
                                  >
                                  <h5>
                                    {{activAccommodation( dailyActivites ).rate}}
                                  </h5>
                                  <img
                                  src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fstar_icon.png?alt=media&token=f2eb5419-e0fd-4c62-b6c2-9499544a5c03"
                                  alt="Star"
                                  width="15px"
                                  height="12px"
                                  >
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <!-- date section -->
                    <div class="d-flex my-3">
                      <div
                        v-if="internallShouldPresentTheDates"
                        class="centering_with_gap flex all_border_blue_for_accommodation_dates">
                        <div class="field">
                          <img 
                           src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fride_summary%2Fcalendar_icon.png?alt=media&token=3be4a7c8-1f53-4778-9f11-2c60dd1defaf"
                           alt="calendar"
                           width="21px"
                           height="24px"
                          >
                        </div>            
                        <div class="field">
                          <i class="calendar icon"></i>
                          <span class="main_ride_dates">{{activAccommodation( dailyActivites ).check_in_date}}</span>
                        </div>
                        <img
                         width="18px"
                         height="20px"
                         src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fride_summary%2Farrow-right-solid.png?alt=media&token=0dbdd199-477a-41a7-a5b2-752a38b4235e"
                         alt="arrow"
                        >
                        <div class="field">
                          <i class="calendar icon"></i>
                          <span class="main_ride_dates">{{activAccommodation( dailyActivites ).check_out_date}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="attraction-buttons-primary" dir="ltr">
                      <div 
                        @click="openGoogleMapsLink( activAccommodation( dailyActivites ) )"
                        class="clikable attraction-nav-button"
                      >
                        <img
                          class="attraction-nav-icon"
                          src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Fmap_letter%2Fmaps_48dp.png?alt=media&token=fd8423d7-27f0-4790-b84d-dbda827197dc"
                          alt="Google Maps"
                          loading="lazy"
                        />
                        <span class="attraction-nav-label">{{ t('navigateToDestination') }}</span>
                      </div>
                      <div
                        v-if="activAccommodation( dailyActivites ).link"
                        @click="goToAndTrigerFaceBookQuery( addLabelIfExists( addhttp( activAccommodation( dailyActivites ).link ) ))"
                        class="clikable attraction-option-button"
                        :aria-label="t('viewPlace')"
                        :title="t('viewPlace')"
                      >
                        <span class="material-icons">open_in_new</span>
                      </div>
                    </div>
                    <div
                      v-if="activAccommodation( dailyActivites ).latitude && (rideTypeIsPrivate === false || ( isUserManager && !booked( dailyActivites ) ) )"
                      class="attraction-buttons-container attraction-buttons-extra"
                      dir="ltr"
                    >
                      <div
                        v-if="activAccommodation( dailyActivites ).latitude && (rideTypeIsPrivate === false || ( isUserManager && !booked( dailyActivites ) ) )"
                        @click="goToSerchAccommodations({ location: activAccommodation( dailyActivites ), isRideManager: isUserManager, dayIndex: index })"
                        class="clikable attraction-button primary"
                      >
                        <span class="material-icons" style="color: white;">hotel</span>
                        {{ (isUserManager && allRide?.ride && compareToUserId( allRide.ride.authorId )) ? t('myHotelsList') : t('recommendedHotels') }}
                      </div>
                    </div>
                    <div
                      v-if="booked( dailyActivites ) && activAccommodation( dailyActivites ).voucherUrls && activAccommodation( dailyActivites ).voucherUrls.length"
                      class="attraction-buttons-container attraction-voucher-row"
                      dir="ltr"
                    >
                      <div
                        @click="openVoucherModal(activAccommodation( dailyActivites ).voucherUrls)"
                        class="clikable attraction-button voucher-button"
                      >
                        <span class="material-icons" style="color: white;">receipt_long</span>
                        {{ activAccommodation( dailyActivites ).voucherUrls.length > 1 ? t('voucherPlural') : t('voucher') }}
                      </div>
                    </div>

                    <div 
                      class="attraction-buttons-container"
                      style="justify-content: flex-end !important;"
                      v-if="compareToUserId( allRide.ride.authorId ) && !isRideLocked"
                    >
                      <div 
                        v-if="(!booked( dailyActivites )&&(compareToUserId( allRide.ride.authorId )))"
                        @click="goToBaseRideAccommodation({ baseRideAccommodation: dailyActivites.base_trip_accommodation, dayIndex: index })"
                        class="clikable attraction-button secondery_button"
                      >
                      <span class="material-icons" >hotel</span>
                        {{ t('enterAccommodationDetails') }}
                      </div>

                      <div 
                        v-if="booked( dailyActivites )"
                        @click="goToRideAccommodation( dailyActivites.accommodation )"
                        class="clikable attraction-button secondery_button"
                      >
                        <span class="material-icons">edit</span>
                          {{ t('edit') }}
                      
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from "@/mixins/translationMixin";
import CollapseText from "@/components/CollapseText";
import config from '../common/config';
import TripCalendarView from './TripCalendarView.vue';
import VoucherViewerModal from '@/components/VoucherViewerModal.vue';



export default {
  name: "SingleRideLegacy",
  mixins: [translationMixin],
  components: {
    CollapseText,
    TripCalendarView,
    VoucherViewerModal,
  },
  data() {
    return {
      fullscreenImageSrc: null,
      internallShouldPresentTheDates: true,
      voucherModal: { visible: false, vouchers: [] },
    }
  },
  computed: {
              ...mapGetters([
                              "allRide",
                              "rideHeader",
                              "rideId",
                              "isAppLoggedIn",
                              "userId",
                              "compareToUserId",
                              "rideType",
                              "rideTypeIsPrivate",
                              "getResizeImageForMobileDevices",
                              "isUserManager",
                              "tripViewMode",
                              "isRideLocked"
                            ]),
              ...mapGetters("theme",  [ "isSubdomain",
                                      ]),

        affiliateSourceText() {
          return (attraction) => {
            // Get affiliate source
            return config.config.PLACE_ID_TO_AFFILIATE_SOURCE_LINK_CONVERTOR[attraction.placeId]?.affiliateSource;
          };
        },

        affiliateSourceColor() {
          return (attraction) => {
            // Get affiliate source
            return config.config.PLACE_ID_TO_AFFILIATE_SOURCE_LINK_CONVERTOR[attraction.placeId]?.collor;
          };
        },

        affiliateSourceIconLink() {
          return (attraction) => {
            // Get affiliate source
            const affiliateSource = config.config.PLACE_ID_TO_AFFILIATE_SOURCE_LINK_CONVERTOR[attraction.placeId]?.affiliateSource;
      
            if (!affiliateSource) {
              console.warn("Affiliate source not found for the given placeId");
              return null; // Handle missing affiliateSource gracefully
            }
      
            // Return the appropriate icon link
            if (affiliateSource === config.constant.GET_YOUR_GUIDE) {
              return config.config.GET_YOUR_GUIDE_ATTRACTION_ICON;
            } else if (affiliateSource === config.constant.TIQETS) {
              return config.config.TIQETS_ATTRACTION_ICON;
            }
      
            return null; // Default case if no match is found
          };
        },
     
        getDayExtraInformationByDate() {
        // returns a function that can be used in the template
          return (date) => {
            return this.rideHeader?.ride?.rideExtraInformationByDay?.find(
              info => info.date === date
            );
          };
        },
  
        config() {
         return config;
        },
        showCalendarView: {
          get() {
            return this.tripViewMode === 'calendar';
          },
          set(value) {
            this.updateTripViewMode(value ? 'calendar' : 'list');
          }
        }

  },
  methods: {
    ...mapActions([
      "fetchRideWithLoadingPopup",
      "fetchRide",
      "serchAttractionToRide",
      "removeDayFromRide",
      "addNewDayToRide",
      "removeAttractionFromRide",
      "validateAndupdateAppToken",
      "editAttraction",
      "viewAttraction",
      "lowedAttraction",
      "openLoginForm",
      "goToNewAttraction",
      "goToRideAccommodation",
      "goToBaseRideAccommodation",
      "showModalWithParameters",
      "showModal",
      "goToBokingDotCom",
      "goToSerchAccommodations",
      "addLabelIfExists",
      "addhttp",
      "shouldPresentTheDates",
      "openExtraInformationForRide",
      "editExtraInformationForRide",
      "updateTripViewMode"
    ]),
    async internalDataShouldPresentTheDates(){
      this.internallShouldPresentTheDates = await this.shouldPresentTheDates()
    },
    toggleImageFullscreen(imageSrc) {
      this.fullscreenImageSrc = imageSrc; // Set new image to fullscreen
    },
    closeImageFullscreen() {
      this.fullscreenImageSrc = null;
    },
    loadErrorImage( event, URL ){
      console.log("image event: ",event ," for url: ",URL)
      event.target.src = URL
    },
    async showModalAttraction( attraction ) {
      this.showModal( "loadingIcon" );
      await this.lowedAttraction( attraction )
      this.showModal( "attraction" );
    },
    confirmAndRemoveDay(dayIndex) {
      if (this.isRideLocked) {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
        return;
      }
      if (this.compareToUserId(this.allRide.ride.authorId)) {
        // Check if this day has extra information
        const dayDate = this.allRide.attractionsByDay[dayIndex]?.dateTime;
        const hasExtraInfo = dayDate && this.rideHeader?.ride?.rideExtraInformationByDay?.find(
          info => info.date === dayDate
        );
        
        if (hasExtraInfo) {
          // Show warning about losing extra information first
          this.showModalWithParameters({
            inerModalParameters: { dayIndex: dayIndex },
            type: "confirmRemoveDayWithExtraInfo",
          });
        } else {
          // No extra info, go directly to regular removal confirmation
          this.showModalWithParameters({
            inerModalParameters: { dayIndex: dayIndex },
            type: "areYouShureRemovingDay",
          });
        }
      } else {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter' } );
      }
    },
    async addNewDayToRideInternal( dayIndex ) {
      if (this.isRideLocked) {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
        return;
      }
      if (this.compareToUserId( this.allRide.ride.authorId )) {
        this.showModal("loadingIcon");
        const success = await this.addNewDayToRide( { dayIndex: dayIndex } );
        
        // Only show success message if the operation succeeded
        if (success) {
          this.showModalWithParameters( { errorNumber : "scroll_down_to_see_the_added_day",
                                          type:'textConverter'  } );
        }

      } else {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
      }
    },
    removeAttractionFromRideInternal(attractionId) {
      if (this.isRideLocked) {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
        return;
      }
      if (this.compareToUserId( this.allRide.ride.authorId )) {
        this.showModalWithParameters( { inerModalParameters : { attractionId: attractionId },
                          type: "areYouShureRemovingAttraction" } );
      } else {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
      }
    },
    openWazeLink(attraction) {
      window.open( 'https://www.waze.com/ul?ll=' + attraction.latitude + '%2C' + attraction.longtitude + '&navigate=yes&zoom=17' , '_blank')
    },
    openGoogleMapsLink(attraction) {
      const lat = attraction.latitude;
      const lng = attraction.longtitude;
      window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank');
    },

    openVoucherLink(voucherUrl) {
      if (voucherUrl) {
        window.open(voucherUrl, '_blank');
      }
    },
    openVoucherModal(vouchers) {
      this.voucherModal = { visible: true, vouchers };
    },
    bookingRideToBookingConvertor(rideId){
      return config.config.RIDE_TO_BOKING_ID_CONVERTOR[rideId]
    },
    bookingBAtttractionIcon(){
      return config.config.BOOKING_B_ATTRACTION_ICON
    },
    linkAtttractionIcon(){
      return config.config.LINK_ATTRACTION_ICON
    },
    shareAtttractionIcon(){
      return config.config.SHARE_ATTRACTION_IMAGE
    },
    googleMapsAtttractionIcon(){
      return config.config.GOOGLE_MAPS_ATTRACTION_ICON
    },
    haveAffiliateSourceLink(attraction) {
      return config.config.PLACE_ID_TO_AFFILIATE_SOURCE_LINK_CONVERTOR[attraction.placeId];
    },
    openAffiliateSourceLink(attraction) {
      window.open( config.config.PLACE_ID_TO_AFFILIATE_SOURCE_LINK_CONVERTOR[attraction.placeId].link , '_blank')

    },
    shareThisAttraction( rideId, attractionId ){
      this.showModalWithParameters( { inerModalParameters : {rideId:rideId, attractionId:attractionId},
                                      type:'shareAttraction' } );
      
    },
    openUpdateAttractionTime(attractionInfo){
      if (this.isRideLocked) {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
        return;
      }
      this.$store.commit("setAttractionForChangeingTheDate", attractionInfo);
      if (this.compareToUserId( this.allRide.ride.authorId )) {
        this.showModal( "updateAttractionTime" );
      } else {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
      }
    },
    activAccommodation( dailyActivites ) {
      if ( Object.keys(dailyActivites.accommodation).length ){
        return dailyActivites.accommodation
      } 
      return dailyActivites.base_trip_accommodation
    },
    booked(dailyActivites){
      if ( this.activAccommodation( dailyActivites ).status == "booked" ){
        return true;
      }
      return false;
    },
    getImageHtmlAttributions( htmlCode ){
      return htmlCode.slice(0,3) + 'target="_blank"' + htmlCode.slice(3)
    },
    getMapAccommodationIcon(){
      return config.config.MAP_POINT_ACCOMMODATION;
    },
    goToAndTrigerFaceBookQuery(link){
      if (window.fbq) {
        window.fbq('track', 'Lead');
        window.fbq('track', 'gooToBooking');
        
      }
      this.goTo(link);
    },
    async goTo( link ){
      // let url = "window.open('" + link + "','_blank')"
      // the link at some trip is not have the boking information, soo this is an work arowend top fix it
      var staticLink = await link;
      if("http://undefined"==staticLink){
        staticLink = 'https://www.booking.com?aid=2186348' + '_blank'
      }   
// order=getaway_deals_upsorter
// https://www.booking.com/searchresults.he.html?aid=2420138&lang=he&sid=c9886691859367a1318d52c5014de95d&sb=1&sb_lp=1&order=getaway_deals_upsorter&src=index&src_elem=sb&error_url=https%3A%2F%2Fwww.booking.com%2Findex.he.html%3Faid%3D2420138%26sid%3Dc9886691859367a1318d52c5014de95d%26sb_price_type%3Dtotal%26%26&ss=%D7%91%D7%A8%D7%9C%D7%99%D7%9F&is_ski_area=0&ssne=%D7%91%D7%A8%D7%9C%D7%99%D7%9F&ssne_untouched=%D7%91%D7%A8%D7%9C%D7%99%D7%9F&dest_id=-1746443&dest_type=city&checkin_year=2024&checkin_month=5&checkin_monthday=23&checkout_year=2024&checkout_month=5&checkout_monthday=26&flex_window=0&group_adults=2&group_children=0&no_rooms=1&b_h4u_keep_filters=&from_sf=1
      window.open(staticLink)
      return 
    },
    choseTheRightEditingOption( attraction ){ 
      if (this.isRideLocked) {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
        return;
      }
      if(this.compareToUserId( attraction.authorId))
        this.editAttraction( attraction.id )
      else
        this.openUpdateAttractionTime( attraction )
    },
    chouseTheRightWayToAddAtraction( dayIndex ){
      if( this.allRide.ride.is_based_ride && this.compareToUserId( this.allRide.ride.authorId ) ) 
        this.goToNewAttraction( dayIndex )
      else
        this.serchAttractionToRide( dayIndex )
      
    },
    async internalEditExtraInformationForRide( rideExtraInformation ){
      if (this.isRideLocked) {
        this.showModalWithParameters( { errorNumber : "uesr_is_not_authorize_to_edit_this_ride",
                                        type:'textConverter'  } );
        return;
      }
      // this is an workarownd to set the date only for the title to not be presented
      this.$store.commit("setExtraInformationForRideDate", rideExtraInformation.date);

      this.$store.dispatch('editExtraInformationForRide', {
                              rideId: this.allRide.ride.id,
                              extraInformationId: rideExtraInformation.id
                            });
    },
    moveDayAttractionsInternal(dailyActivites, dayIndex) {
      if (this.isRideLocked) {
        this.showModalWithParameters({ errorNumber: "uesr_is_not_authorize_to_edit_this_ride", type: "textConverter" });
        return;
      }
      this.$store.commit("setAttractionForChangeingTheDate", dailyActivites);
      if (this.compareToUserId(this.allRide.ride.authorId)) {
        this.showModalWithParameters({
          inerModalParameters: { sourceDayInfo: dailyActivites, dayIndex },
          type: "moveDayAttractions",
        });
      } else {
        this.showModalWithParameters({ errorNumber: "uesr_is_not_authorize_to_edit_this_ride", type: "textConverter" });
      }
    },
 },
//  updated(){
//   (function (d, sc, u) {
//       var s = d.createElement(sc),
//         p = d.getElementsByTagName(sc)[0];
//       s.type = "text/javascript";
//       s.async = true;
//       s.src = u + "?v=" + +new Date();
//       p.parentNode.insertBefore(s, p);
//     })(
//       document,
//       "script",
//       "//aff.bstatic.com/static/affiliate_base/js/flexiproduct.js"
//     );
   
//  },
  created() {
    this.validateAndupdateAppToken();
    this.fetchRide();
  },
  watch: {
    isAppLoggedIn(newVal) {
      if( newVal && this.allRide){
        this.fetchRide();
      }
    },
    allRide() {
      this.internalDataShouldPresentTheDates()
    }
  },
};

</script>

<style scoped>
.secondery_button {
  background-color: #F5F5F5 !important;
  color: black;
}

.google-maps-button {
  background: var(--secondary-background);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.14);
  transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
  direction: rtl;
}

.google-maps-button:hover {
  filter: brightness(1.03);
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
}

.google-maps-button:active {
  transform: translateY(0);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.18);
}

.google-maps-button .google-maps-app-icon {
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 3px;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 999px;
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.18);
  outline: 1px solid rgba(0, 0, 0, 0.08);
  flex: 0 0 auto;
}

.google-maps-button .google-maps-label {
  font-weight: 800;
  letter-spacing: 0.2px;
  line-height: 1;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.attraction-buttons-container {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem 0.6rem;
  margin-top: 2rem;
}

.attraction-button {
  flex: 1 1 113px; /* flex-grow:1, flex-shrink:1, flex-basis:113px */
  max-width: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1rem;
  font-size: 1.6rem;
  border-radius: 999px;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;
  height: 44px;
  gap: 0.5rem;
}

.attraction-button img {
  width: 20px;
  height: 20px;
  margin-left: 0.5rem
}

.fullscreen-overlay {
  padding-top: 5rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.8); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullscreen-overlay img {
  max-width: 90%; /* Ensure some margin around the image */
  max-height: 90%;
  object-fit: contain; /* Ensures the image is fully visible */
}

.close-button {
  position: absolute;
  top: 60px;
  right: 20px;
  padding: 10px;
  font-size: 24px;
  color: white;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 1001;
  font-weight: 700;
}

.three-colomn .add-activity-add-icon{
font-size: 5rem;
line-height: 3.4rem;
color: #E3A21E;
height: 4rem;
width: 4rem;
padding: 0px 0px;
border: 0.3rem solid #E3A21E;
border-radius: 4.5rem;
}

.three-colomn{
  display: grid;
  column-gap: 2rem;
  row-gap: 14.1rem;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 3rem;
  justify-items: center;
  align-items: center;
}

.three-dots{
  font-size: 10.7rem;
}

.new_information {
  display: none !important;
}

.res-row {
  min-height: 235px;
}

@media (max-width: 575.98px) {
  .res-row {
    min-height: 235px;
  }
}
@media (min-width: 768px) and (max-width: 1023.98px) {
  .res-row {
    min-height: 235px;
  }
}
@media (min-width: 1024.98px) {
  .res-row {
    min-height: 283px;
  }
}

.view-toggle-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.btn-group {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  overflow: hidden;
}

.btn-group .btn {
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  border: none;
}

.btn-group .btn i {
  margin-left: 0.5rem;
}

.btn-primary {
  background-color: #07A0C3;
  color: white;
}

.btn-outline-primary {
  color: #07A0C3;
  background-color: white;
}

.btn-outline-primary:hover {
  background-color: #f0f8fa;
}

/* Attraction media section (video, audio, voucher) */
.attraction-media-section {
  border-top: 1px solid #f0f0f0;
  padding-top: 1rem;
  direction: rtl;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.attraction-media-item {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.attraction-media-item:last-child {
  margin-bottom: 0;
}

.attraction-media-label {
  font-weight: 600;
  font-size: 1.4rem;
  color: #0D2F29;
}

.attraction-media-video {
  width: 100%;
  max-width: 320px;
  max-height: 240px;
  border-radius: 8px;
  background: #000;
  margin: 0 auto;
}

.attraction-media-audio {
  width: 100%;
  max-width: 320px;
  height: 40px;
  margin: 0 auto;
}

.voucher-button {
  background: var(--secondary-background);
  color: white;
}

.voucher-button:hover {
  filter: brightness(0.9);
}

.voucher-button .material-icons {
  font-size: 20px;
}

.attraction-voucher-row {
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid #f0f0f0;
}

.ride-activity-index {
  font-size: 41px !important;
  line-height: 41px !important;
}

.ride-accommodation-index {
  font-size: 41px !important;
  line-height: 41px !important;
}

.attraction-buttons-primary {
  display: flex;
  gap: 10px;
  align-items: stretch;
  margin-top: 1.5rem;
}

.attraction-nav-button {
  flex: 1;
  min-height: 48px;
  border-radius: 12px;
  background: var(--secondary-background);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  cursor: pointer;
}

.attraction-nav-button:hover {
  filter: brightness(1.03);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.16);
}

.attraction-nav-icon {
  width: 24px;
  height: 24px;
  padding: 2px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 999px;
}

.attraction-nav-label {
  font-weight: 700;
  font-size: 16px;
}

.attraction-option-button {
  width: 52px;
  min-height: 48px;
  border-radius: 12px;
  background: #fff;
  color: #374151;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.attraction-option-button:hover {
  background: #f9fafb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.attraction-option-button .material-icons {
  font-size: 24px;
}

.attraction-buttons-extra {
  margin-top: 1rem !important;
}

/* Add margin before ALL attraction buttons containers to create separation */
.activity.card .attraction-buttons-container {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f0f0f0;
  clear: both; /* Clear any floated elements above */
}

/* Ensure date section has proper spacing */
.activity.card .card-body .d-flex.my-3 {
  margin-bottom: 1rem !important;
}

/* Make trip-default-btn buttons smaller on desktop/full screen */
@media (min-width: 1200px) {
  a.trip-default-btn {
    font-size: 16px !important;
    padding: 12px !important;
    line-height: 20px !important;
  }
}

/* Medium screens - slightly smaller than default */
@media (min-width: 768px) and (max-width: 1199px) {
  a.trip-default-btn {
    font-size: 18px !important;
    padding: 14px !important;
    line-height: 24px !important;
  }
}


</style>
